import Joi from '@hapi/joi'

export const operationEntityConfigurationSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Please select valid Company`,
        "any.required": `Company required`
    }),
    collectionPointID: Joi.number().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    configurationName: Joi.string().invalid("").label("Configuration Name").required().messages({
        "any.invalid": `Configuration Name Required`,
        "any.required": `Configuration Name Required`
    }),
    configurationValue: Joi.number().label("Configuration Value").messages({
        "any.invalid": `Configuration Value Required`,
        "any.required": `Configuration Value Required`
    }),
    configurationType: Joi.number().label("Configuration Type").messages({
        "any.invalid": `Configuration Type Required`,
        "any.required": `Configuration Type Required`
    }),
    measuringUnit: Joi.number().label("MeasuringUnit").messages({
        "any.invalid": `Measuring Unit Required`,
        "any.required": `Measuring Unit Required`
    }),
    minValue: Joi.number().label("MinValue").messages({
        "any.invalid": `Min Value Required`,
        "any.required": `Min Value Required`
    }),
    maxValue: Joi.number().label("MaxValue").messages({
        "any.invalid": `Max Value Required`,
        "any.required": `Max Value Required`
    }),
    JsonString: Joi.string().label("JsonString").messages({
        "any.invalid": `Text Value Required`,
        "any.required": `Text Value Required`
    }),
    configurationTypeID: Joi.number().label("Configuration TypeID").messages({
        "any.invalid": `Please select valid ConfigurationTypeID`,
        "any.required": `ConfigurationTypeID required`
    }),
    collectionPointList: Joi.number().label("collectionPointList").messages({
        "any.invalid": `Please select valid collectionPointList`,
        "any.required": `collectionPointList required`
    }),
    isApply: Joi.boolean().label("Is Apply"),
    isActive: Joi.boolean().label("Is Active")
    


    
    
}